// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"_a971ff5","submit":"_4e92bb4","firstGroup":"_e0a59fd","bottomText":"_488bf4c"};